export default {
  /**时间格式化方法 */
  dateToString(str) {
    let date = new Date(str);
    return `${date.getFullYear()}-${date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
      }-${date.getDate() < 9 ? "0" + date.getDate() : date.getDate()} ${date.getHours() < 9 ? "0" + date.getHours() : date.getHours()
      }:${date.getMinutes() < 9 ? "0" + date.getMinutes() : date.getMinutes()
      }:${date.getSeconds() < 9 ? "0" + date.getSeconds() : date.getSeconds()}`;
  },
}